__turbopack_context__.v({
  "button": "PlasmicRemarketing-module__bmXyua__button",
  "freeBox": "PlasmicRemarketing-module__bmXyua__freeBox",
  "h1": "PlasmicRemarketing-module__bmXyua__h1",
  "li__ejszj": "PlasmicRemarketing-module__bmXyua__li__ejszj",
  "root": "PlasmicRemarketing-module__bmXyua__root",
  "svg__hwSjR": "PlasmicRemarketing-module__bmXyua__svg__hwSjR",
  "svg__ySjUp": "PlasmicRemarketing-module__bmXyua__svg__ySjUp",
  "text___8P0TJ": "PlasmicRemarketing-module__bmXyua__text___8P0TJ",
  "text___8S2G": "PlasmicRemarketing-module__bmXyua__text___8S2G",
  "text__bzwo4": "PlasmicRemarketing-module__bmXyua__text__bzwo4",
  "text__kMQjA": "PlasmicRemarketing-module__bmXyua__text__kMQjA",
  "text__ob9T8": "PlasmicRemarketing-module__bmXyua__text__ob9T8",
  "text__pXsM": "PlasmicRemarketing-module__bmXyua__text__pXsM",
  "text__rcGjv": "PlasmicRemarketing-module__bmXyua__text__rcGjv",
  "text__z9DUk": "PlasmicRemarketing-module__bmXyua__text__z9DUk",
  "ul___6ERff": "PlasmicRemarketing-module__bmXyua__ul___6ERff",
  "ul__x1PsV": "PlasmicRemarketing-module__bmXyua__ul__x1PsV",
  "ul__zNnAh": "PlasmicRemarketing-module__bmXyua__ul__zNnAh",
});
